import routes from './routes';
import { SetRoutes } from 'components';

const LeasingContactsMainPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default LeasingContactsMainPage;
